@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

@if (filterable && surveys?.length > 0) {
  <div class="container background-filters py-3 px-5 mt-3">
    <div class="row justify-content-between">
      <div class="purple-color">
        <h2>{{'generic.search-for' | translate}}</h2>
      </div>
      <div>
        <button class="clear-filter py-2 px-4" (click)="onClickResetFilters()">{{'generic.reset-filters' | translate}} <i class="icon-Close ml-2 size"></i></button>
      </div>
    </div>
    <div class="row d-flex justify-content-between align-items-center m-0">
      <div>
        <mat-form-field class="datepicker-primary wp-normal color-default mx-2 p-0" appearance="fill" mx-2>
          <mat-label>{{ 'generic.start_date' | translate }}</mat-label>
          <input matInput name="startDate" class="ng-trim-ignore" (dateChange)="applyFilterToDataSource()" [placeholder]="'GG/MM/AAAA' | translate" [matDatepicker]="pickerStartDate" [(ngModel)]="searchModel.startDate">
          <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
          <mat-datepicker #pickerStartDate></mat-datepicker>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="datepicker-primary wp-normal color-default p-0" appearance="fill">
          <mat-label>{{ 'generic.end_date' | translate }}</mat-label>
          <input matInput name="endDate" class="ng-trim-ignore" (dateChange)="applyFilterToDataSource()" [placeholder]="'GG/MM/AAAA' | translate" [matDatepicker]="pickerEndDate" [(ngModel)]="searchModel.endDate">
          <mat-datepicker-toggle matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
          <mat-datepicker #pickerEndDate></mat-datepicker>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="select-primary wp-normal color-default p-0" appearance="fill">
          <mat-label>{{ "generic.type" | translate }}</mat-label>
          <mat-select [formControl]="selectedTypologies" multiple (selectionChange)="applyFilterToDataSource()">
            @for (type of typologiesList; track type) {
              <mat-option [value]="type">{{type}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row d-flex justify-content-between mx-0 mt-2">
      <div class="col-12 col-md-12 mt-4">
        <mat-form-field class="full-width">
          <input matInput name="searchKeywords" [(ngModel)]="searchModel.name" type="text" placeholder="{{'pages.frameworks.all-frameworks.component.search-name' | translate}}" (keyup)="applyFilterToDataSource()">
          @if (searchModel.name) {
            <mat-icon class="with-cursor" matSuffix aria-label="Clear" (click)="searchModel.name=''; applyFilterToDataSource()">close</mat-icon>
          }
          <mat-icon class="purple-color with-cursor" matSuffix aria-label="Clear" (click)="applyFilterToDataSource()">search</mat-icon>
        </mat-form-field>
      </div>
    </div>
  </div>
}

@if (surveys?.length == 0) {
  <div class="container px-0">
    @if (addable) {
      <div class="row">
        <div class="col-12 d-flex justify-content-end align-items-center mb-4 mt-2">
          <button class="btn-custom btn-magic-add d-flex align-items-center px-5 py-2" (click)="addNewSurvey()">
            <mat-icon class="mr-2">add</mat-icon>
            {{ 'routing.title.surveys' | translate}}
          </button>
        </div>
      </div>
    }
    <div class="row">
      <div class="col-12 text-center d-flex flex-column align-items-center">
        <img src="assets/img/no-files.png" alt="" class="no-files-img mb-3">
        <p class="color-green">{{'pages.projects.project-detail.no-surveys' | translate}}</p>
      </div>
    </div>
  </div>
}
@if (surveys?.length > 0) {
  <div class="container px-0">
    @if (addable) {
      <div class="row">
        <div class="col-12 d-flex justify-content-end align-items-center mb-4 mt-2">
          <button class="btn-custom btn-magic-add d-flex align-items-center px-5 py-2" (click)="addNewSurvey()">
            <mat-icon class="mr-2">add</mat-icon>
            {{ 'routing.title.surveys' | translate}}
          </button>
        </div>
      </div>
    }
    <div class="mat-elevation-z8 table-container-rounded">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="table-primary">
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-title"> {{ 'generic.name' | translate }} </th>
          <td mat-cell *matCellDef="let element" class="col-title"> {{ element.title }} </td>
        </ng-container>
        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-narrow"> {{ 'pages.decision-management-plan.component.opening-date' | translate }} </th>
          <td mat-cell *matCellDef="let element" class="col-narrow"> {{ element.created_at | date:'shortDate'}} </td>
        </ng-container>
        <ng-container matColumnDef="created_by_user">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-narrow"> {{ "generic.created-by" | translate }} </th>
          <td mat-cell *matCellDef="let element" class="col-narrow"> {{ getCreatorFullNameBySurvey(element) }} </td>
        </ng-container>
        <ng-container matColumnDef="session_number">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-narrow"> {{ "generic.session" | translate }} </th>
          <td mat-cell *matCellDef="let element" class="col-narrow"> {{ element?.session_number }} </td>
        </ng-container>
        <ng-container matColumnDef="visibility_type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-narrow"> {{ "generic.type" | translate }} </th>
          <td mat-cell *matCellDef="let element" class="col-narrow">
            <mat-chip-grid>
              <!-- Visibility type chip -->
              <mat-chip [ngClass]="element.visibility_type === 'PUBLIC' ? 'chip-public' : 'chip-private'" class="text-white">
                {{ element.visibility_type | titlecase }}
              </mat-chip>
              <!-- Revision chip -->
              @if (element.version_number > 1) {
                <mat-chip class="chip-revision text-white">
                  Revision
                </mat-chip>
              }
              <!-- Draft chip -->
              @if (element.is_draft) {
                <mat-chip class="chip-draft text-white">
                  Draft
                </mat-chip>
              }
            </mat-chip-grid>
          </td>
        </ng-container>
        <ng-container matColumnDef="versionsNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-narrow"> {{ "generic.versions" | translate }} </th>
          <td mat-cell *matCellDef="let element" class="col-narrow"> {{ element?.versionsNumber }} </td>
        </ng-container>
        <ng-container matColumnDef="revisionsNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-narrow"> {{ "generic.sessions" | translate }} </th>
          <td mat-cell *matCellDef="let element" class="col-narrow"> {{ element?.revisions?.data?.length }} </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-actions"> {{ 'generic.action' | translate }} </th>
          <td mat-cell *matCellDef="let element" class="col-actions">
            @if (surveyViewable) {
              <button mat-button class="ml-2 go-to-survey-btn"
                [routerLink]="['/surveys/' + element.id]" routerLinkActive="router-link-active">
                <small>{{'generic.buttons.go-to-survey' | translate}}</small>
                <mat-icon iconPositionEnd>forward</mat-icon>
              </button>
            }
            @if (surveySelectable) {
              <button mat-button class="go-to-survey-btn" routerLinkActive="router-link-active"
                (click)="surveySelected.emit(element)">
                <small>{{'generic.select' | translate}}</small>
                <mat-icon iconPositionEnd>forward</mat-icon>
              </button>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="outerColumnsToDisplay.length" [class.sessions-righino-td]="(element.revisions?.data?.length || 0) > 1">
            @if ((element.revisions?.data?.length || 0) > 1) {
              <div class="sessions-righino-row" (click)="toggleSessionsRow(element, $event)">
                <mat-icon class="sessions-toggle-icon" [class.rotated]="expandedSessionsElement !== element">expand_more</mat-icon>
                <span class="sessions-toggle-label">Sessioni del sondaggio</span>
                <div class="sessions-righino-line"></div>
              </div>
              <div class="example-element-detail" [@detailExpand]="expandedSessionsElement === element ? 'expanded' : 'collapsed'">
                <div class="inner-expanded-content">
                  <div class="inner-filter-wrapper pl-4">
                      <mat-form-field subscriptSizing="dynamic" class="inner-filter-field p-0" appearance="outline">
                      <mat-icon matPrefix class="search-icon-prefix">search</mat-icon>
                      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                    </mat-form-field>
                  </div>
                  <div class="mat-elevation-z8 table-container-rounded inner-table-card">
                    <table #innerTables mat-table #innerSort="matSort" [dataSource]="element.revisions" matSort class="table-primary table-no-stripe inner-sessions-table">
                        <ng-container matColumnDef="title">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'generic.name' | translate }} </th>
                          <td mat-cell *matCellDef="let element"> {{ element.title }} </td>
                        </ng-container>
                        <ng-container matColumnDef="created_at">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'pages.decision-management-plan.component.opening-date' | translate }} </th>
                          <td mat-cell *matCellDef="let element"> {{ element.created_at | date:'shortDate'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="created_by_user">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "generic.created-by" | translate }} </th>
                          <td mat-cell *matCellDef="let element"> {{ getCreatorFullNameBySurvey(element) }} </td>
                        </ng-container>
                        <ng-container matColumnDef="session_number">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "generic.session" | translate }} </th>
                          <td mat-cell *matCellDef="let element"> {{ element?.session_number }} </td>
                        </ng-container>
                        <ng-container matColumnDef="visibility_type">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "generic.type" | translate }} </th>
                          <td mat-cell *matCellDef="let element">
                            <mat-chip-list>
                              <!-- Revision chip -->
                              @if (element.version_number == '1.0') {
                                <mat-chip class="chip-public text-white">
                                  Origin
                                </mat-chip>
                              }
                              <!-- Revision chip -->
                              @if (element.version_number > 1) {
                                <mat-chip class="chip-revision text-white">
                                  Revision
                                </mat-chip>
                              }
                              <!-- Draft chip -->
                              @if (element.is_draft) {
                                <mat-chip class="chip-draft text-white">
                                  Draft
                                </mat-chip>
                              }
                            </mat-chip-list>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'generic.action' | translate }} </th>
                          <td mat-cell *matCellDef="let element">
                            @if (surveyViewable) {
                              <button mat-button
                                class="ml-2 go-to-survey-btn"
                                (click)="goToSurvey(element.id)"
                                >
                                <small>{{ 'generic.buttons.go-to-survey' | translate }}</small>
                                <mat-icon iconPositionEnd>forward</mat-icon>
                              </button>
                            }
                            @if (surveySelectable) {
                              <button mat-button class="go-to-survey-btn" routerLinkActive="router-link-active" (click)="surveySelected.emit(element)">
                                <small>{{'generic.select' | translate}}</small>
                                <mat-icon iconPositionEnd>forward</mat-icon>
                              </button>
                            }
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
                      </table>
                    </div>
                  </div>
              </div>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="outerColumnsToDisplay"></tr>
        <tr mat-row
          *matRowDef="let element; columns: outerColumnsToDisplay;"
          [class.example-element-row]="(element.revisions?.data?.length || 0) > 1"
          [class.has-righino-row]="(element.revisions?.data?.length || 0) > 1"
          [class.hoverable]="(element.revisions?.data?.length || 0) > 1 || outerTableRowIsNavigable"
          [class.example-expanded-row]="expandedSessionsElement === element"
          (click)="toggleRow(element)">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" [ngClass]="{'sessions-detail-row': (row?.revisions?.data?.length || 0) > 1}"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]"
        #paginator
        aria-label="Select page of periodic elements">
      </mat-paginator>
    </div>
  </div>
}
